import React from 'react';
import { BRAND } from '../../data/brand';

export default function JsonLd() {
  const json = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": BRAND.name,
    "description": "Гипнотерапия: работа с тревогой, стрессом, привычками. Онлайн и очно. Первая консультация бесплатно.",
    "telephone": BRAND.phone,
    "email": BRAND.email,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": BRAND.address,
    },
    "url": BRAND.website,
    "sameAs": [
      BRAND.social.instagram,
      BRAND.social.facebook,
      BRAND.social.linkedin
    ],
    "areaServed": "Worldwide",
    "openingHours": "Mo-Fr 10:00-18:00",
    "priceRange": "€€",
    "currenciesAccepted": "EUR",
    "paymentAccepted": "Credit Card, Bank Transfer, PayPal",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Услуги гипнотерапии",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Старт - Разовая сессия",
            "description": "Разовая сессия 60–75 минут. Подходит, чтобы попробовать и определить стратегию.",
            "price": "90",
            "priceCurrency": "EUR"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Фокус - 3 сессии",
            "description": "3 сессии за 3–4 недели. Для конкретного запроса: тревога, стресс, привычки.",
            "price": "240",
            "priceCurrency": "EUR"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Глубина - 6 сессий",
            "description": "6 сессий и сопровождение. Для устойчивых изменений и сложных запросов.",
            "price": "440",
            "priceCurrency": "EUR"
          }
        }
      ]
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Марина"
        },
        "reviewBody": "После 4 сессий перестала заедать стресс. Появился спокойный сон и силы на спорт."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Артём"
        },
        "reviewBody": "Анна помогла подготовиться к публичному выступлению — без паники и с уверенностью."
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "300",
      "bestRating": "5",
      "worstRating": "1"
    },
    "serviceType": [
      "Гипнотерапия",
      "Психологическое консультирование",
      "Работа с тревогой",
      "Контроль привычек",
      "Повышение уверенности"
    ],
    "availableService": [
      {
        "@type": "MedicalTherapy",
        "name": "Гипнотерапия для снижения тревоги",
        "description": "Специализированные техники для работы с тревожными состояниями"
      },
      {
        "@type": "MedicalTherapy",
        "name": "Гипнотерапия для контроля привычек",
        "description": "Эффективные методы избавления от нежелательных привычек"
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  );
}
